import { NavLink } from "react-router-dom";
import { Link } from "@mui/material";

import { appRoutes, externalRoutes } from "routes";
import logo from "assets/images/common/logo.png";
import twitterLogo from "assets/images/common/twitter.png";
import facebookLogo from "assets/images/common/facebook.png";
import instagramLogo from "assets/images/common/instagram.png";
import pinterestLogo from "assets/images/common/pinterest.png";
import youtubeLogo from "assets/images/common/youtube.png";

import NotSellMyDataLink from "./components/NotSellMyDataLink";
import { Main, Logo, Nav, NavLink as StyledNavLink, Social, SocialLogo, Copyright } from "./styles";

const Footer = () => {
  return (
    <div>
      <Main>
        <Link id="footer-logo" to={appRoutes.rootPath()} component={NavLink}>
          <Logo src={logo} alt="JibJab" width={98} height={90} widthMobile={98} />
        </Link>

        <Nav>
          <StyledNavLink id="footer-about" to={appRoutes.aboutUsPath()} component={NavLink}>
            About
          </StyledNavLink>
          <StyledNavLink id="footer-help" href={externalRoutes.helpPath()} target="_blank" rel="noreferrer">
            Help
          </StyledNavLink>
          <StyledNavLink id="footer-terms" to={appRoutes.termsOfServicePath()} component={NavLink}>
            Terms
          </StyledNavLink>
          <StyledNavLink id="footer-privacy" to={appRoutes.privacyPath()} component={NavLink}>
            Privacy
          </StyledNavLink>
        </Nav>

        <Social>
          <Link href={externalRoutes.twitterPath()} target="_blank" rel="noreferrer">
            <SocialLogo id="footer-twitter" src={twitterLogo} alt="JibJab Twitter" width={32} widthMobile={32} />
          </Link>
          <Link href={externalRoutes.facebookPath()} target="_blank" rel="noreferrer">
            <SocialLogo id="footer-facebook" src={facebookLogo} alt="JibJab Facebook" width={32} widthMobile={32} />
          </Link>
          <Link href={externalRoutes.instagramPath()} target="_blank" rel="noreferrer">
            <SocialLogo id="footer-instagram" src={instagramLogo} alt="JibJab Instagram" width={32} widthMobile={32} />
          </Link>
          <Link href={externalRoutes.pinterestPath()} target="_blank" rel="noreferrer">
            <SocialLogo id="footer-pinterest" src={pinterestLogo} alt="JibJab Pinterest" width={32} widthMobile={32} />
          </Link>
          <Link href={externalRoutes.youtubePath()} target="_blank" rel="noreferrer">
            <SocialLogo id="footer-youtube" src={youtubeLogo} alt="JibJab Youtube" width={32} widthMobile={32} />
          </Link>
        </Social>
      </Main>

      <NotSellMyDataLink />

      <Copyright variant="caption" align="center">
        JibJab®, Sendables®, Starring You® and JokeBox® are registered trademarks of JibJab Catapult CA, Inc. ©
        Copyright 1999–{new Date().getFullYear()} JibJab Catapult CA, Inc. All Rights Reserved.
      </Copyright>
    </div>
  );
};

export default Footer;
